import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Header } from './Header';

@Injectable({
  providedIn: 'root'
})
export class HeaderNavService {

  private option = new BehaviorSubject<Header>({ name:'intro', icon: 'inp-icon-flows-o'});
  public customOption = this.option.asObservable();
  constructor() {}
  public changeOption(option: Header): void {
    this.option.next(option);
  }
}
